// @owner ClientPlatform

import React from 'react';
import type {FC, ReactNode} from 'react';
import {css, styled} from 'styled-components';
import {type TextColor, textColors, textStyles, type TextVariant} from '../theme/textStyles';

/*
 * Mixin.
 */

interface TextStyleMixinProps {
  $variant?: TextVariant;
  $shouldTruncate?: boolean;
  $color?: TextColor;
}
export const textStyleMixin = ({$variant, $shouldTruncate, $color}: TextStyleMixinProps) => css`
  margin: 0;

  ${$variant &&
  css`
    font-size: ${textStyles[$variant].fontSize};
    line-height: ${textStyles[$variant].lineHeight};
    font-weight: ${textStyles[$variant].fontWeight};
  `}

  ${$color &&
  css`
    color: ${textColors[$color]};
  `}

  ${$shouldTruncate &&
  css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

/*
 * Component.
 */

type TextElement = 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface TextProps {
  variant?: TextVariant;
  color?: TextColor;
  as?: TextElement;
  shouldTruncate?: boolean;
  children: ReactNode;
}

const StyledText = styled.span<{
  $variant?: TextVariant;
  $shouldTruncate?: boolean;
  $color?: TextColor;
}>`
  ${textStyleMixin}
`;

export const Text: FC<TextProps> = ({as = 'span', variant, color, shouldTruncate, children}) => (
  <StyledText as={as} $variant={variant} $color={color} $shouldTruncate={shouldTruncate}>
    {children}
  </StyledText>
);
